import * as yup from 'yup';

function productLineName(formatMessage) {
  return yup
    .string()
    .required(
      formatMessage({
        id: 'PRODUCT_LINE_NAME_IS_REQUIRED',
        defaultMessage: 'Product Line Name is required',
      }),
    )
    .max(
      64,
      formatMessage({
        id: 'CREATEFORM_PRODUCTLINENAME_FIELD_MAX_CHARS_64',
        defaultMessage: 'Product Line Name should be less than 64 chars',
      }),
    );
}

function productLineCode(formatMessage) {
  return yup
    .string()
    .required(
      formatMessage({
        id: 'PRODUCT_LINE_CODE_IS_REQUIRED',
        defaultMessage: 'Product Line Code is required',
      }),
    )
    .max(
      32,
      formatMessage({
        id: 'CREATEFORM_PRODUCTLINECODE_FIELD_MAX_CHARS_32',
        defaultMessage: 'Product Line Code should be less than 32 chars',
      }),
    );
}

function status(formatMessage) {
  return yup.string().required(
    formatMessage({
      id: 'STATUS_IS_REQUIRED',
      defaultMessage: 'Status is required',
    }),
  );
}

const validationSchema = formatMessage =>
  yup
    .object({
      productLineName: productLineName(formatMessage),
      productLineCode: productLineCode(formatMessage),
      status: status(formatMessage),
    })
    .required();

export default validationSchema;
